import StackTrace, { StackFrame } from 'stacktrace-js';
import StackTraceGPS from 'stacktrace-gps';

/**
 * Parses an error into stack frames (stack trace)
 * @param error The error to parse
 */
export const parseStackTrace = (error: Error): Promise<StackFrame[]> => {
  return StackTrace.fromError(error, { offline: true });
};

/**
 * Resolves the frames actual source location using source map
 * @param frame The frame to map against sourcemap
 */
export const pinpointFrame = (frame: StackFrame): Promise<StackFrame> => {
  const gps = new StackTraceGPS();
  return gps.pinpoint(frame).catch(() => frame);
};
